import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class signupFormView_template extends vnTemplate {

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , idForm: ko.observable("")
            , label: ko.observable("")
            , buttonText: ko.observable("")
            , fields: ko.observableArray([])
            , mailingLists: ko.observableArray([])
            , onClickEditSignupForm: function (data, event) {
                self.onClickEditSignupForm(data.id());
            }
            , onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title" data-bind="text: label"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditSignupForm }" class="btn icon i-edit"  type="button">Edit Signup Form</button>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Form ESP ID</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: idForm"></span>
                                </dd>
                                <dt>
                                    <span>Form Internal Name</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: label"></span>
                                </dd>
                                <dt>
                                    <span>Form Button Text</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: buttonText"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                    <div class="form-body">
                    </div>
                </div>

                <div class="w-form-body" style="margin-top: -1.25rem">
                    <div class="form-body full-width  no-border" style="position: relative;">

                    </div>
               </div>

                <div class="w-form-body">

                </div>

                <div class="w-form-body" style="margin-top: -1.25rem">

                    <div class="form-body " style="position: relative;">
                        <strong class="form-sub-title">Fields</strong>
                        <div class="form-group" data-bind="visible: fields().length == 0"><p class="form-text">No Fields</p></div>
                        <div id="field_section" class="form-group field" data-bind="visible: fields().length != 0">
                            <table id="field_list" class="list-action full-width" >
                                <thead>
                                    <tr style="background-color: #8a8a8a">
                                        <th><span>Label (ESP ID)</span></th>
                                        <th><span>Is Required</span></th>
                                        <th><span>Default Value</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: fields">
                                    <tr>
                                        <td><span data-bind="text: labelID"></span></td>
                                        <td><span data-bind="text: isRequired"></span></td>
                                        <td><span data-bind="text: defaultValue"></span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="form-body " style="position: relative;">
                        <strong class="form-sub-title">Mailing Lists</strong>
                        <div class="form-group" data-bind="visible: mailingLists().length == 0"><p class="form-text">No mailing lists</p></div>
                        <div id="mailing_list_section" class="form-group mailing_list" data-bind="visible: mailingLists().length != 0">
                            <table id="mailing_list" class="list-action full-width" >
                                <thead>
                                    <tr style="background-color: #8a8a8a">
                                        <th><span>Label (ESP ID)</span></th>
                                        <th><span>Is Selected by Default</span></th>
                                        <th><span>Description</span></th>
                                        <th><span>Image</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: mailingLists">
                                    <tr>
                                        <td><span data-bind="text: labelID"></span></td>
                                        <td><span data-bind="text: isSelected"></span></td>
                                        <td><span data-bind="text: description"></span></td>
                                        <td class="small-img">
                                            <span class="small-img"><img data-bind="attr: { src: image }, visible: image"></span>
                                            <span data-bind="text: 'False', visible: !image"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>


            </div>
        `);
    }

    protected setSignupFormData(signupForm) {
        this.getTemplateViewModel().id(signupForm.id)
        this.getTemplateViewModel().idForm(signupForm.idForm)
        this.getTemplateViewModel().label(signupForm.label)
        this.getTemplateViewModel().buttonText(signupForm.buttonText)

        for (let field of signupForm.fields) {
            field.labelID = field.label + " (" + field.idFieldGiven + ")";
        }
        for (let mailingList of signupForm.mailingLists) {
            mailingList.labelID = mailingList.label + " (" + mailingList.idMailingListGiven + ")";
        }
        this.getTemplateViewModel().fields(signupForm.fields)
        this.getTemplateViewModel().mailingLists(signupForm.mailingLists)
    }

    protected getTemplateName(): string {
        return "signupFormView_template";
    }

    protected onClickEditSignupForm(id: any): any {
        this.caller.onClickEditSignupForm(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/signupFormView_template.ts